import { updateCommonErrorMessage, updateCommonSuccessMessage, updateCommonWarnMessage } from "@/redux/actions/weevilTrakAction";
import { RootState } from "@/redux/reducer/store";
import { Modal } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Outlet } from "react-router-dom";

const WeevilTrakHome = ()=>{

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const errorMessage = useSelector((state: RootState) => state.weevTrakReducer.errorMessage);
    const successMessage = useSelector((state: RootState) => state.weevTrakReducer.successMessage);
    const warningMessage = useSelector((state: RootState) => state.weevTrakReducer.warningMessage);

    const errorNotification = (message: string) => {
        Modal.error({
            title: "Error",
            content: message,
            className: "custom-modal-ok-button",// 应用自定义样式类名
            zIndex: 9999, // 确保模态框在最上层
        });
    };

    const warningNotification = (message: string) => {
        Modal.warning({
            title: "Warning",
            content: message,
            className: "custom-modal-ok-button",// 应用自定义样式类名
            zIndex: 9999, // 确保模态框在最上层

        });
    };
    const successNotification = (message: string) => {
        Modal.success({
            title: "Success",
            content: message,
            className: "custom-modal-ok-button",// 应用自定义样式类名
            zIndex: 9999, // 确保模态框在最上层
        });
    };
    useEffect(() => {
        if (errorMessage) {
            errorNotification(errorMessage);
            dispatch(updateCommonErrorMessage(""));
        }
        if (warningMessage) {
            warningNotification(warningMessage);
            dispatch(updateCommonWarnMessage(""));
        }
        if (successMessage) {
            successNotification(successMessage);
            dispatch(updateCommonSuccessMessage(""));
        }
    }, [errorMessage, warningMessage, successMessage]);

    useEffect(() => {
        const userEmail = localStorage.getItem("weeviltrak-useremail");
        if(userEmail==undefined || userEmail==""){
            navigate("/weeviltrak/login");
        }else{
            navigate("/weeviltrak/home");
        }
    },[]);

    return (
        <div className="weeviltrak-layout">
            {/* 2. 添加 Outlet，子路由内容将显示在这里 */}
            <Outlet />
        </div>
    );
};

export default WeevilTrakHome;